import React from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  DesktopManageHouseholdMember,
} from 'Views/Page/Content/Templates/ProfilePage/ManageHouseholdMember/DesktopManageHouseholdMember';
import {
  MobileManageHouseholdMember,
} from 'Views/Page/Content/Templates/ProfilePage/ManageHouseholdMember/MobileManageHouseholdMember';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';


export const ManageHouseholdMember = ({
  resource, onDeleteMember, onSubmitSuccess,
}) => {
  const isMobile = useMobileLayout();
  if (!resource && !isMobile) {
    return <Skeleton height={541} width={'100%'} variant={'rect'} style={{ margin: '0 32px 0 32px', borderRadius: '16px' }} />;
  }

  if (!resource && isMobile) {
    return null;
  }

  if (isMobile) {
    return (<MobileManageHouseholdMember
      resource={resource}
      onDeleteMember={onDeleteMember}
      onSubmitSuccess={onSubmitSuccess}
    />);
  }

  return (
    <DesktopManageHouseholdMember
      resource={resource}
      onDeleteMember={onDeleteMember}
      onSubmitSuccess={onSubmitSuccess}
    />
  );
};

ManageHouseholdMember.propTypes = {
  resource: PropTypes.object.isRequired,
  onDeleteMember: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};
